import { render, staticRenderFns } from "./StellateBlock.vue?vue&type=template&id=c0373b74&scoped=true"
import script from "./StellateBlock.vue?vue&type=script&lang=js"
export * from "./StellateBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0373b74",
  null
  
)

export default component.exports